/* TITANSHIELD Air —— 捲動、圖表與計數。只操作自己的元素。 */
if(!window.__tsAirInit){ window.__tsAirInit = 1;
(function(){
  "use strict";
  var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  var clamp = function(v,a,b){ return v<a?a:(v>b?b:v); };

  /* ---------- 進場淡入 ---------- */
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add("in"); io.unobserve(e.target); } });
  }, {rootMargin:"0px 0px -12% 0px", threshold:.08});
  document.querySelectorAll(".rise").forEach(function(n){ io.observe(n); });

  /* ---------- 數字滾動 ---------- */
  var cio = new IntersectionObserver(function(es){
    es.forEach(function(e){
      if(!e.isIntersecting) return;
      cio.unobserve(e.target);
      var el = e.target, end = parseFloat(el.dataset.count), dec = +el.dataset.dec;
      var unit = el.querySelector("em"), t0 = null, dur = 1400;
      if(reduce){ el.firstChild.nodeValue = end.toFixed(dec); return; }
      requestAnimationFrame(function step(t){
        if(t0===null) t0 = t;
        var p = clamp((t-t0)/dur,0,1), e2 = 1-Math.pow(1-p,3);
        el.firstChild.nodeValue = (end*e2).toFixed(dec);
        if(p<1) requestAnimationFrame(step);
      });
    });
  }, {threshold:.5});
  document.querySelectorAll("[data-count]").forEach(function(n){ cio.observe(n); });

  /* ---------- 厚度長條 ---------- */
  var bio = new IntersectionObserver(function(es){
    es.forEach(function(e){
      if(!e.isIntersecting) return;
      bio.unobserve(e.target);
      var mm = parseFloat(e.target.dataset.mm), f = e.target.querySelector(".tbar__fill");
      f.style.height = Math.max(3, mm*2.2) + "px";
      f.style.width = (mm/15*100) + "%";
    });
  }, {threshold:.4});
  document.querySelectorAll(".tbar").forEach(function(n){ bio.observe(n); });

  /* ---------- 捲到才跑的視覺 ---------- */
  function once(sel, fn, opts){
    var o = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ o.unobserve(e.target); fn(e.target); } });
    }, typeof opts === "number" ? {threshold:opts} : (opts || {threshold:.35}));
    document.querySelectorAll(sel).forEach(function(n){ o.observe(n); });
  }

  /* 重量對照：以 200 g 為滿格 */
  once(".wbar", function(el){
    el.querySelector("i").style.width = (parseFloat(el.dataset.g)/200*100) + "%";
  });

  /* 鋁 vs 塑膠：熱從中心擴散的程度差很多 */
  once(".heat__plate", function(el){ el.classList.add("on"); }, .5);

  /* 充電曲線：等圖真的進到畫面裡才從基線往上長，不要在畫面外就演完 */
  once(".chart", function(el){ el.classList.add("on"); }, {threshold:.32, rootMargin:"0px 0px -16% 0px"});

  /* 額定容量：2800 佔 5000 的比例 */
  once("#cap", function(){
    var r = document.getElementById("capReal");
    if(r) r.style.width = (2800/5000*100) + "%";
  });

  /* 各機型可充到幾 % */
  once(".phone", function(el){
    el.querySelector("i").style.width = el.dataset.pct + "%";
  }, .5);

  /* ---------- 爆炸圖層 ---------- */
  /* 七層照拆解動畫由上到下的真實堆疊（2026-08-18 Mars 口述定案，EVA 改隔熱金屬面板） */
  var LAYERS = [
    {n:"鋁合金外殼",       d:"CNC 一體成型，同時是散熱面"},
    {n:"石墨烯散熱層",     d:"貼在電芯上方，把熱攤開帶走"},
    {n:"準固態鋰離子電芯", d:"5000 mAh／19.25 Wh，兩層"},
    {n:"Type-C 接頭",      d:"輸入與輸出共用同一個埠"},
    {n:"隔熱金屬面板",     d:"擋在電芯與線圈之間，把熱隔開"},
    {n:"N52 磁力線圈",     d:"磁吸對位＋無線充電"},
    {n:"強化玻璃面板",     d:"貼著手機的那一面"}
  ];
  var xpList = document.getElementById("xpList");
  /* 2026-08-19 SEO：清單改由 Liquid 渲染（ts-exploded.liquid），這裡只在沒渲染時後備生成 */
  if(xpList && !xpList.children.length) LAYERS.forEach(function(L,i){
    var li = document.createElement("div");
    li.className = "xp__item"; li.dataset.i = i;
    li.innerHTML = '<i>'+String(i+1).padStart(2,"0")+'</i><div><b>'+L.n+'</b><span>'+L.d+'</span></div>';
    xpList.appendChild(li);
  });
  var xpItems = xpList ? [].slice.call(xpList.children) : [];

  /* ---------- 捲動主迴圈 ---------- */
  var pin = document.querySelector(".pin"), xp = document.querySelector(".xp"),
      needleG = document.getElementById("needleG"), glow = document.getElementById("glow"),
      gfill = document.getElementById("gfill"),
      hole = document.getElementById("hole"), tempEl = document.getElementById("temp"),
      voltEl = document.getElementById("volt"), verdict = document.getElementById("verdict"),
      heroModel = document.getElementById("heroModel"),
      snapRings = document.getElementById("snapRings"), snapPack = document.getElementById("snapPack"),
      hero = document.querySelector(".hero");

  function prog(el){
    var r = el.getBoundingClientRect(), h = el.offsetHeight - innerHeight;
    return clamp((0 - r.top) / (h>0?h:1), 0, 1);
  }

  var ticking = false;
  function frame(){
    ticking = false;
    var y = scrollY, vh = innerHeight;

    /* Hero 產品浮動 */
    if(heroModel && hero && !reduce){
      var hr = hero.getBoundingClientRect();
      if(hr.bottom > 0){
        var p = clamp(-hr.top/vh,0,1);
        heroModel.style.transform = "translateY("+(p*-60)+"px) scale("+(1-p*.08)+")";
        heroModel.style.opacity = String(1-p*.75);
      }
    }

    /* 穿刺段 */
    if(pin){
      var pr = pin.getBoundingClientRect();
      if(pr.top < vh && pr.bottom > 0){
        var p2 = prog(pin);
        var drop = clamp((p2-.10)/.42,0,1);              /* 鋼針下降 */
        var ease = 1-Math.pow(1-drop,2.4);
        needleG.setAttribute("transform","translate(0,"+(-330+ease*330)+")");

        var pierced = clamp((p2-.44)/.42,0,1);           /* 穿透之後 */
        hole.setAttribute("rx", (7*pierced).toFixed(2));
        hole.setAttribute("ry", (5*pierced).toFixed(2));
        glow.setAttribute("r", (30*pierced).toFixed(1));
        glow.setAttribute("opacity", (pierced*.8).toFixed(2));

        var temp = 25 + (44.0-25)*pierced;
        tempEl.textContent = temp.toFixed(1);
        var gh = temp * 2.76;                            /* 0°C 在 y=338、100°C 在 y=62 */
        gfill.setAttribute("height", gh.toFixed(1));
        gfill.setAttribute("y", (338-gh).toFixed(1));
        voltEl.textContent = (4.458*(1-clamp((p2-.46)/.16,0,1))).toFixed(3);
        verdict.classList.toggle("on", p2 > .80);
      }
    }

    /* 爆炸圖 */
    if(xp){
      var xr = xp.getBoundingClientRect();
      if(xr.top < vh && xr.bottom > 0){
        var p3 = prog(xp);
        var spread = clamp(p3/.55,0,1);
        var eas = 1-Math.pow(1-spread,2.2);
        var active = Math.round(clamp((p3-.5)/.46,0,1) * (LAYERS.length-1));
        var anyActive = p3 > .52;
        xpItems.forEach(function(el,i){ el.classList.toggle("on", anyActive && i === active); });
        if(window.__air3d) window.__air3d.setExplode(eas, anyActive ? active : -1);
      }
    }

    /* MagSafe 吸附 */
    if(snapPack){
      var sr = snapPack.getBoundingClientRect();
      if(sr.top < vh*.86 && sr.bottom > 0){
        snapPack.style.transform = "translateY(0)";
        snapPack.style.opacity = "1";
        snapRings.style.opacity = "1";
      }
    }
  }
  function onScroll(){ if(!ticking){ ticking = true; requestAnimationFrame(frame); } }
  addEventListener("scroll", onScroll, {passive:true});
  addEventListener("resize", onScroll);

  if(snapPack && !reduce){
    snapPack.style.transition = "transform 1s cubic-bezier(.16,.84,.44,1), opacity .8s";
    snapPack.style.transform = "translateY(-54px)";
    snapPack.style.opacity = "0";
    snapRings.style.transition = "opacity .9s .35s";
  }



  /* 顏色切換 */
  var sw = document.getElementById("sw");
  if(sw) sw.addEventListener("click", function(e){
    var b = e.target.closest("button[data-c]"); if(!b) return;
    document.documentElement.style.setProperty("--body", b.dataset.c);
    sw.querySelectorAll("button").forEach(function(x){ x.setAttribute("aria-pressed", String(x===b)); });
    var box = document.getElementById("swatchbox");
    if(box) box.querySelectorAll("img").forEach(function(im){
      im.classList.toggle("on", im.dataset.col === b.dataset.c);
    });
  });

  
  frame();
})();

}
